import { Text } from '@chakra-ui/react';
import React from 'react';

export const FieldLabel = ({
  children,
  required,
}: {
  children: React.ReactNode;
  required?: boolean;
}) => (
  <Text fontWeight={600} fontSize="14px" color="text.darkBlue">
    {children}
    {required && (
      <Text as="span" color="extra.red">
        {' '}
        *
      </Text>
    )}
  </Text>
);

export const FieldError = ({ error }: { error?: string }) =>
  error ? (
    <Text color="extra.red" fontSize="13px">
      {error}
    </Text>
  ) : null;
